import { Post } from '@/api/api-middleware';
import {
  LoginUserApi,
  RefreshTokenUserApi,
  LogoutApi,
  LoginAzureApi,
} from '@/api/api-request/auth-request';
import { apiPathLogin } from '@/constants/defaultValues';

const Login = async (userName, password) => {
  const response = Post({
    url: `${apiPathLogin}${LoginUserApi}`,
    data: { userName, password },
  });
  return response;
};
const RefreshToken = async (token, refreshToken) => {
  const response = Post({
    url: `${apiPath}${RefreshTokenUserApi}`,
    data: {
      accessToken: token,
      refreshToken: refreshToken,
    },
  });
  return response;
};

const Logout = async (refreshToken, token) => {
  const response = Post({
    url: `${apiPath}${LogoutApi}`,
    data: {
      token,
      refreshToken,
    },
  });
  return response;
};
const AzureLogin = async (userName, azureToken) => {
  const response = Post({
    url: `${apiPathLogin}${LoginAzureApi}`,
    data: { idToken: azureToken },
  });
  return response;
};
const AuthApi = {
  Login,
  Logout,
  RefreshToken,
  AzureLogin,
};
export default AuthApi;
